module.exports = __webpack_public_path__ + "static/img/p2rc.2ab4f45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p2rc.png
// module id = 0Pr3
// module chunks = 73